<template>
  <div v-if="logoColors.length > 0" class="km__modules__logo--colors">
    <ul class="km__list--modules" :class="'anz_color' + logoColors.length">
      <li class="km__list__element--modules" v-for="color in logoColors" :key="color.colorCode">
        <button class="km__button--standard" @click="colorPickerClicked(color)"
                :class="{border:colorIsNearWhite(color.colorIntValue)}"
                :style="{'background-color': backgroundColor(color)}"
                :data-name="getColorNameFunction(color)"
                aria-label="changecolor"
        ></button>
        <span class="km__label--text w_70">{{ getColorNameFunction(color) }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {useStore} from "vuex";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {getColorName} from "@km/store/ColorDataGetterFromResourceStore";
import {CONSTANTS} from "@k/js/meta_data";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";

const props = defineProps({logoColors: {type: Array, required: true}});
const emit = defineEmits(["colorPickerClicked"]);
const store = useStore();
const openStatusStore = useModuleLogoOpenStateStore();
setWatchToAnimateOnStatechange(
    AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation(".km__modules__logo--color"),
    new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 100, opacity: 0}),
    () => openStatusStore.getColorState
);


const colorPickerClicked = (color) => emit("colorPickerClicked", color);
const backgroundColor = (color) => ColorUtilsVue.hexWithPoundsign(color, "colorIntValue");
const colorIsNearWhite = ColorUtilsVue.colorIntIsNearWhite;
const getColorNameFunction = (color) => getColorName(store, CONSTANTS.STANDARD_PALETTENCLUSTER, color.palette, color.colorIntValue);

</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__logo--colors {
  position: fixed;
  height: 49px;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 99;
  background: config.$color-white;
  padding: 0;
  overflow-y: hidden;

  .km__button--standard {
    width: 60px;
  }

  .km__label--text {
    height: 15px;
  }
}

.km__list--modules {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;

  &.anz_color5 {
    padding-bottom: 90px;
    overflow-x: scroll;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    -ms-scroll-snap-type: x mandatory;
    -webkit-scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
  }

  .km__list__element--modules {
    margin: 0 12px;
    position: relative;
  }
}
</style>
